import { Video, VideoRef } from '@cue/molecules';
import { Dayjs, TimeUtil } from '@cue/utility';
import { useEvents } from '@project/hooks/use-events';
import { useMediaAnalytics } from '@project/hooks/use-media-analytics';
import { useMemo, useRef, useState } from 'react';

type VodProps = typeof Video & {
  slug: 'agenda';
  day: Dayjs;
  eventId: string;
};

interface VideoInfo {
  id: string;
  links: { type: string; href: string; title: string | null }[];
}

function extractVideoTimes(videoArray: VideoInfo[]): { id: string; start: number; end: number }[] {
  const result: { id: string; start: number; end: number }[] = [];

  for (let i = 0; i < videoArray.length - 1; i++) {
    const currentLink = videoArray[i].links.find((link) => link.type === 'video');
    const nextLink = videoArray[i + 1].links.find((link) => link.type === 'video');

    if (currentLink && nextLink) {
      const start = extractTimeFromUrl(currentLink.href);
      const end = extractTimeFromUrl(nextLink.href);
      result.push({ id: videoArray[i].id, start: Number(start), end: Number(end) });
    }
  }

  return result;
}

function extractTimeFromUrl(url: string): string {
  const params = new URLSearchParams(url.split('?')[1]);
  return params.get('t') || '';
}

export const Vod = (props: VodProps) => {
  const videoRef = useRef<VideoRef>(null);
  const [currentEvent, setCurrentEvent] = useState<string>(props.eventId);
  const { events } = useEvents();

  const eventsMapped = useMemo(() => {
    const e = events
      ?.filter((e) => {
        return props.day.isSame(TimeUtil.getUtc(e.start), 'day');
      })
      ?.sort((s1, s2) => (TimeUtil.getUtc(s1.start).isBefore(TimeUtil.getUtc(s2.start)) ? -1 : 1));
    return extractVideoTimes((e as unknown as VideoInfo[]) || []);
  }, [props.slug, events]);

  const updateProgress = (progress: number) => {
    if (eventsMapped) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const cEvent = eventsMapped.find((video) => progress >= video.start && progress <= video.end);

      if (cEvent) {
        setCurrentEvent(cEvent.id);
      }
    }
  };

  return (
    <>
      <Video
        {...props}
        ref={videoRef}
        useMediaAnalytics={useMediaAnalytics}
        trackingTitle={JSON.stringify({ event: currentEvent })}
        onProgressUpdate={(progress: number) => updateProgress(progress)}
      />
    </>
  );
};
